import {formatTitle} from "../colourwayBuilders"
import State from "../../models/State"
import {getTileSummaryData} from "../getTileSummaryData"

export const getProductTitle = (state: State, itemNumber: string): string => {
    const {enabledSearchDesc, summaryItemsData} = state.productSummary
    const {isEnglishLang} = state.request

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const summaryData = getTileSummaryData(summaryItemsData, itemNumber)
    const {title, colourways, department, fit} = summaryData

    const getColourways = colourways || []
    const selectedColourway = getColourways.find(colourway => colourway.s)
    const formattedTitle: string = enabledSearchDesc
        ? selectedColourway?.t || ""
        : formatTitle({
              title,
              selectedColourway,
              fit,
              department,
              isEnglishLang,
          })

    return formattedTitle
}
